import { UUID } from 'v2/core/entities/uuid';
import { getSavedSlug } from 'v2/core/services/savedSlug/utils';
import pathJoin from 'v2/core/utils/path';

export const getDashboardRoute = ({
  name,
  token,
}: {
  name: string;
  token: UUID;
}): string => {
  const slug = getSavedSlug({
    name,
    token,
  });
  return `/${pathJoin('dashboard', slug)}`;
};

export const getDashboardLink = ({
  name,
  token,
  tenantSlug,
}: {
  name: string;
  token: UUID;
  tenantSlug?: string;
}): string => {
  const route = getDashboardRoute({
    name,
    token,
  });
  return pathJoin(window.location.origin, tenantSlug ?? '', route);
};
